import SortAndPagination from './SortAndPagination';

export default SortAndPagination;
